import * as React from 'react';
import { composer } from '../../../component-decorators/composer';
import { Heading, Box, Button, Divider, ModalMobileLayout, TextButton, Modal, RadioGroup, } from 'wix-style-react';
import { useConfigContext } from '../../../config-context';
import { getCurrentLanguageText, getLanguagesForMenu, } from '../../standalone-header/header-user-details/header-desktop-user-details/header-desktop-languages-popover/header-desktop-languages-popover-content/languages';
import { Languages } from 'wix-ui-icons-common';
import { getLanguageLinkHref } from '../../standalone-header/header-user-details/header-desktop-user-details/header-desktop-languages-popover/header-desktop-languages-popover-content/utils';
export var MobileMenuLanguages = function () {
    var locale = useConfigContext().locale;
    var _a = React.useState(false), isModalOpen = _a[0], setIsModalOpen = _a[1];
    var closeModal = function () {
        setIsModalOpen(false);
    };
    var openModal = function () {
        setIsModalOpen(true);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Divider, null),
        React.createElement(Box, { paddingTop: "24px", paddingBottom: "18px" },
            React.createElement(TextButton, { as: "button", dataHook: "languages-mobile-menu", skin: "dark", prefixIcon: React.createElement(Languages, null), onClick: openModal }, getCurrentLanguageText(locale))),
        React.createElement(MobileLanguageSelector, { isModalOpen: isModalOpen, updateCloseModalState: closeModal })));
};
var MobileLanguageSelector = composer()
    .withMarketplaceStore()
    .withTranslation()
    .withExperiments()
    .compose(function (_a) {
    var isModalOpen = _a.isModalOpen, updateCloseModalState = _a.updateCloseModalState, t = _a.t, marketplaceStore = _a.marketplaceStore, experiments = _a.experiments;
    // tslint:disable-next-line:react-hooks-nesting
    var locale = useConfigContext().locale;
    // tslint:disable-next-line:react-hooks-nesting
    var _b = React.useState(locale), selectedLanguage = _b[0], setSelectedLanguage = _b[1];
    var showIndonesianLanguage = experiments.enabled('specs.marketplace.addIndonesianLanguage');
    var onChooseLanguageClick = function () {
        if (selectedLanguage === locale) {
            updateCloseModalState();
        }
        else if (selectedLanguage) {
            window.location.href = getLanguageLinkHref(!!marketplaceStore.userName, selectedLanguage);
        }
    };
    var closeModal = function () {
        updateCloseModalState();
        setSelectedLanguage(locale);
    };
    return (React.createElement(Modal, { isOpen: isModalOpen, onRequestClose: closeModal, contentLabel: "Language selector", scrollableContent: true },
        React.createElement(ModalMobileLayout, { fullscreen: true, onCloseButtonClick: closeModal, stickyFooter: true, stickyTitle: true, title: React.createElement(Heading, { appearance: "H2" }, t('mobile.menu.languages.selector.title')), content: React.createElement(Box, { direction: "vertical" },
                React.createElement(RadioGroup, { display: "vertical", onChange: function (value) {
                        setSelectedLanguage(value);
                    }, vAlign: "center", value: selectedLanguage }, getLanguagesForMenu(locale, showIndonesianLanguage).map(function (language) { return (React.createElement(RadioGroup.Radio, { value: language.languageCode, key: language.languageCode }, language.text)); }))), footer: React.createElement(Box, { align: "right" },
                React.createElement(Box, { marginRight: "12px" },
                    React.createElement(Button, { priority: "secondary", onClick: closeModal, dataHook: "language-selector-cancel-button" }, t('mobile.menu.languages.selector.cancel.button'))),
                React.createElement(Button, { dataHook: "language-selector-choose-button", onClick: onChooseLanguageClick }, t('mobile.menu.languages.selector.choose.button'))) })));
});
//# sourceMappingURL=mobile-menu-languages.js.map